import { createAction } from 'redux-actions'

import * as constants from './constants'

export const searchListing = createAction(constants.SEARCH_LISTING)
export const searchListingPending = createAction(constants.SEARCH_LISTING_PENDING)
export const searchListingSuccess = createAction(constants.SEARCH_LISTING_SUCCESS)
export const searchListingFailed = createAction(constants.SEARCH_LISTING_FAILED)